import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer-area">
      <div className="footer-widget">
        <div className="container">
          <div className="row footer-widget-wrapper pt-100 pb-70">
            <div className="col-md-6 col-lg-4">
              <div className="footer-widget-box about-us">
                <h4 className="footer-widget-title">About Us</h4>
                <p className="mb-3">
                  Orient Elevators Pvt. Ltd. is one of India’s leading providers
                  of elevator and escalator solutions, dedicated to redefining
                  vertical transportation through innovation, safety, and
                  reliability. With a strong foundation built on engineering
                  excellence.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="footer-widget-box list">
                <h4 className="footer-widget-title">Quick Links</h4>
                <ul className="footer-list">
                  <li>
                    <Link to="/">
                      <i className="fas fa-caret-right"></i> Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/About">
                      <i className="fas fa-caret-right"></i> About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/Service">
                      <i className="fas fa-caret-right"></i> Services
                    </Link>
                  </li>
                  <li>
                    <Link to="/contactus">
                      <i className="fas fa-caret-right"></i> Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div className="footer-widget-box list">
                <h4 className="footer-widget-title">Contact Us</h4>
                <ul className="footer-contact">
                  <li>
                    <i className="far fa-map-marker-alt"></i>Sector-17, Indira
                    Nagar, Lucknow, UP 226016
                  </li>
                  <li>
                    <a href="tel:+919415003780">
                      <i className="far fa-phone"></i> 9415003780 |
                      9918001880
                    </a>
                  </li>

                  <li>
                    <a href="mailto:orientelevators@refiffmail.com">
                      <i className="far fa-envelope"></i> orientelevators@refiffmail.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-12 align-self-center">
              <p className="copyright-text text-center">
                ©2025 Orient Elevators All Rights Reserved.Design &amp;
                Developed By{" "}
                <a
                  href="https://inventicsoft.com/"
                  class="text-white"
                  target="_blank"
                >
                  {" "}
                  <b>InventicSoft IT Solutions</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
